<div class="rs-endcap" #rsEndcap>
  <!-- ===================== PRE-FOOTER CTA ===================== -->
  <section class="rs-precta">
    <div class="rs-precta__deco" aria-hidden="true">
      <span class="rs-precta__blob rs-precta__blob--1"></span>
      <span class="rs-precta__blob rs-precta__blob--2"></span>
      <span class="rs-precta__dots rs-precta__dots--1"></span>
      <span class="rs-precta__dots rs-precta__dots--2"></span>
      <span class="rs-precta__spark" style="--sx: 16%; --sy: 30%; --sd: 0s"></span>
      <span class="rs-precta__spark" style="--sx: 84%; --sy: 22%; --sd: 1.4s"></span>
      <span class="rs-precta__spark" style="--sx: 70%; --sy: 70%; --sd: 0.7s"></span>
    </div>

    <div class="container rs-precta__inner">
      <span class="rs-precta__eyebrow">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
          <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
        </svg>
        Let&rsquo;s Build Something Amazing
      </span>

      <h2 class="rs-precta__title">
        Connect With Our
        <span class="rs-precta__title-grad">Business Experts</span>
      </h2>

      <p class="rs-precta__lede">
        Whether you&rsquo;re building a website, mobile application, enterprise
        software, or AI solution, our experts are ready to help transform your
        ideas into reality.
      </p>

      <div class="rs-precta__action">
        <app-consult-now-modal id="requestcallbackdialog"></app-consult-now-modal>
        <span class="rs-precta__note" aria-hidden="true">
          <svg class="rs-precta__swirl" viewBox="0 0 90 40" fill="none">
            <path d="M4 30 C 18 6, 30 4, 34 14 C 37 22, 26 26, 24 18 C 22 10, 40 4, 62 12 C 74 16, 80 20, 86 26" stroke="#ff2d95" stroke-width="1.6" stroke-dasharray="4 5" stroke-linecap="round" />
            <path d="m80 20 6 6-8 2" stroke="#ff2d95" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          We will get back to you!
        </span>
      </div>
    </div>
  </section>

  <!-- ===================== FOOTER ===================== -->
  <footer class="rs-foot">
    <div class="rs-foot__deco" aria-hidden="true">
      <span class="rs-foot__mesh"></span>
      <span class="rs-foot__grid-lines"></span>
      <span class="rs-foot__blob rs-foot__blob--1"></span>
      <span class="rs-foot__blob rs-foot__blob--2"></span>
      <span class="rs-foot__dots"></span>
      <span class="rs-foot__spark" style="--sx: 22%; --sy: 18%; --sd: 0.4s"></span>
      <span class="rs-foot__spark" style="--sx: 58%; --sy: 72%; --sd: 1.6s"></span>
      <span class="rs-foot__spark" style="--sx: 88%; --sy: 30%; --sd: 0.9s"></span>
    </div>

    <div class="container rs-foot__inner">
      <div class="rs-foot__grid">
        <!-- ---------- brand ---------- -->
        <div class="rs-foot__col rs-foot__brand" style="--c: 0">
          <a href="https://www.resiliencesoft.com" class="rs-foot__logo">
            <img loading="lazy" src="assets/images/footer-logo.webp" alt="resiliencesoft" />
          </a>
          <p class="rs-foot__about">
            ResilienceSoft is a leading IT solutions company delivering
            innovative, scalable and impactful digital experiences that help
            businesses grow and succeed.
          </p>

          <ul class="rs-foot__social">
            <li>
              <a href="https://www.facebook.com/OfficialResiliencesoft" target="_blank" aria-label="Facebook"><i class="fab fa-facebook"></i></a>
            </li>
            <li>
              <a href="https://www.instagram.com/resiliencesoftofficial" target="_blank" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
            </li>
            <li>
              <a href="https://x.com/ResilienceSoft1" target="_blank" aria-label="X (Twitter)"><i class="fab fa-twitter"></i></a>
            </li>
            <li>
              <a href="https://in.pinterest.com/resiliencesoft/" target="_blank" aria-label="Pinterest"><i class="fab fa-pinterest"></i></a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCLCk552hkub1znblDNwqcBw" target="_blank" aria-label="YouTube"><i class="fab fa-youtube"></i></a>
            </li>
          </ul>

          <ul class="rs-foot__badges">
            <li>Trusted Worldwide</li>
            <li>500+ Projects</li>
            <li>20+ Countries</li>
            <li>Client First</li>
          </ul>

          <a class="rs-foot__msgcard" routerLink="/contact-us">
            <span class="rs-foot__msgcard-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 12a8 8 0 0 1 16 0" /><path d="M3 14a2 2 0 0 1 2-2h1v6H5a2 2 0 0 1-2-2z" /><path d="M21 14a2 2 0 0 0-2-2h-1v6h1a2 2 0 0 0 2-2z" /><path d="M19 18a3 3 0 0 1-3 3h-2" />
              </svg>
            </span>
            <span>
              <strong>Let&rsquo;s build something great together!</strong>
              <small>We are just a message away.</small>
            </span>
          </a>
        </div>

        <!-- ---------- important links ---------- -->
        <nav class="rs-foot__col" style="--c: 1" aria-label="Important links">
          <h3 class="rs-foot__head">
            <span class="rs-foot__head-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" /><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" /></svg>
            </span>
            Important Links
          </h3>
          <ul class="rs-foot__links">
            <li><a routerLink="/">Home</a></li>
            <li><a routerLink="/about-us">About us</a></li>
            <li><a routerLink="/software-Development">Services</a></li>
            <li><a routerLink="/our-portfolio">Our portfolio</a></li>
            <li><a routerLink="/contact-us">Contact us</a></li>
          </ul>
        </nav>

        <!-- ---------- web solutions ---------- -->
        <nav class="rs-foot__col" style="--c: 2" aria-label="Web solutions">
          <h3 class="rs-foot__head">
            <span class="rs-foot__head-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m8 6-6 6 6 6" /><path d="m16 6 6 6-6 6" /></svg>
            </span>
            Web Solution
          </h3>
          <ul class="rs-foot__links">
            <li><a routerLink="service/website-Design">Website Designing</a></li>
            <li><a routerLink="service/software-Development">Software Development</a></li>
            <li><a routerLink="service/Web-Application-Development">Web Application Development</a></li>
            <li><a routerLink="service/web-Hosting-Solutions">Web Hosting Solutions</a></li>
          </ul>

          <h3 class="rs-foot__head rs-foot__head--gap">
            <span class="rs-foot__head-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 20V10M9 20V4M15 20v-7M21 20V8" /></svg>
            </span>
            Digital Marketing
          </h3>
          <ul class="rs-foot__links">
            <li><a routerLink="service/search-Engine-Optimisation">Search Engine Optimisation</a></li>
            <li><a routerLink="service/digital-Media-Marketing">Digital Media Marketing</a></li>
            <li><a routerLink="service/social-Media-Promotion">Social Media Promotion</a></li>
            <li><a routerLink="service/bulk-Sms-and-Email-Marketing">Bulk Sms &amp; Email Marketing</a></li>
          </ul>
        </nav>

        <!-- ---------- app solutions ---------- -->
        <nav class="rs-foot__col" style="--c: 3" aria-label="App solutions">
          <h3 class="rs-foot__head">
            <span class="rs-foot__head-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="6.5" y="2.5" width="11" height="19" rx="2.5" /><path d="M11 18.5h2" /></svg>
            </span>
            App Solution
          </h3>
          <ul class="rs-foot__links">
            <li><a routerLink="service/android-app-development">Android App Development</a></li>
            <li><a routerLink="service/ios-app-development">Ios App Development</a></li>
            <li><a routerLink="service/hybrid-app-development">Hybrid App Development</a></li>
            <li><a routerLink="service/native-app-development">Native App Development</a></li>
          </ul>
        </nav>

        <!-- ---------- contact ---------- -->
        <div class="rs-foot__col rs-foot__contact" style="--c: 4">
          <h3 class="rs-foot__head">
            <span class="rs-foot__head-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M21.4 2.6a1 1 0 0 0-1.06-.23l-17 6.5a1 1 0 0 0 .06 1.88l7.2 2.25 2.25 7.2a1 1 0 0 0 1.88.06l6.5-17a1 1 0 0 0-.23-1.06z" /></svg>
            </span>
            Get in Touch
          </h3>

          <a class="rs-foot__card" routerLink="/contact-us" fragment="maplocation">
            <span class="rs-foot__card-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0z" /><circle cx="12" cy="10" r="3" /></svg>
            </span>
            <span>2nd Floor Emerald Plaza, Telephone Exchange Road, Opposite CG Plaza, Bilaspur (C.G) Pin 495001</span>
          </a>

          <a class="rs-foot__card" href="mailto:info@resiliencesoft.com">
            <span class="rs-foot__card-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="4.5" width="19" height="15" rx="2.5" /><path d="m3 7 9 6 9-6" /></svg>
            </span>
            <span>info&#64;resiliencesoft.com</span>
          </a>

          <div class="rs-foot__card">
            <span class="rs-foot__card-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 3.5h4l1.5 4.5-2.5 1.5a12 12 0 0 0 6 6l1.5-2.5 4.5 1.5v4a2 2 0 0 1-2.18 2A17.5 17.5 0 0 1 3 5.68 2 2 0 0 1 5 3.5z" /></svg>
            </span>
            <span class="rs-foot__tels">
              <a href="tel:9109911372">9109911372</a>
              <a href="tel:9201996377">9201996377</a>
              <a href="tel:9201996378">9201996378</a>
            </span>
          </div>
        </div>
      </div>

      <!-- ---------- bottom bar ---------- -->
      <div class="rs-foot__rule" aria-hidden="true"></div>
      <div class="rs-foot__bottom">
        <p class="rs-foot__copy">
          Copyright &copy; <span>{{ currentYear }}</span> ResilienceSoft. All
          Rights Reserved
        </p>
        <ul class="rs-foot__policies">
          <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
          <li><a routerLink="/terms-of-service">Terms &amp; Conditions</a></li>
          <li><a routerLink="/cancellation-policy">Cancellation Policy</a></li>
        </ul>
        <p class="rs-foot__made">
          Made with <span aria-label="love">&#10084;&#65039;</span> in India
        </p>
      </div>
    </div>

    <app-trust-btn-modal></app-trust-btn-modal>
  </footer>
</div>
